import {
  DROPSHIP_REVENUE,
  DROPSHIP_ALLOWED,
  REPLENISH_ALLOWED,
  PERMISSIONS_TAB,
  PERMISSIONS_MINIMUM_ORDER_PRODUCTS,
  PERMISSIONS_MINIMUM_ORDER_VALUE,
  PERMISSIONS_FIXED_PER_UNIT,
  PERMISSIONS_PERCENTAGE,
  CURRENT_RETAILER_TERMS,
  PERMISSIONS_CHANGED,
  REPLENISH_SHIPPER_ACCOUNT,
  REPLENISH_DAYS_UNTIL_OVERDUE,
  ECOMMERCE_DAYS_UNTIL_OVERDUE,
} from '../constants/permissionsTypes';

import { TAB_DROPSHIP } from '../../constants/mainConstants';
import {
  COMMISSION_TYPE_MSRP,
  COMMISSION_TYPE_REV_SHARE,
  COMMISSION_TYPE_UNIT_PRICE,
  COMMISSION_TYPE_WHOLESALE,
} from '../../constants/commissionTypes';

const initialState = {
  ecommerce_billing_method: 'none',
  replenish_billing_method: 'none',
  ecommerce_unit_price_formula: 'retail_price*70/100',
  approved_for_ecommerce: false,
  approved_for_replenishment: false,
  minimum_order_value_for_replenishment_order: 0,
  minimum_products_for_replenishment_order: 0,
  replenishment_order_shipping_cost_percentage: 0,
  replenishment_order_shipping_cost_fixed_per_unit: 0,
  replenishment_shipper_account_type: null,
  replenishment_shipper_account: null,
  ecommerce_send_invoice: false,
  ecommerce_invoice_net_plus: 30,
  replenish_send_invoice: false,
  replenish_invoice_net_plus: 30,
  changed: false,
  tab: TAB_DROPSHIP,
};

const permissions = (state = initialState, action) => {
  switch (action.type) {
    case DROPSHIP_REVENUE:
      let ecommerce_unit_price_formula = null;
      if (action.commission_type === COMMISSION_TYPE_WHOLESALE) {
        ecommerce_unit_price_formula = 'wholesale_price';
        if (action.payload > 0) {
          const value = Math.round(action.payload * 100);
          ecommerce_unit_price_formula += `+${value}`;
        }
      } else if (action.commission_type === COMMISSION_TYPE_MSRP) {
        const percentage = 100 - action.payload;
        ecommerce_unit_price_formula = `retail_price*${percentage}/100`;
      } else if (action.commission_type === COMMISSION_TYPE_REV_SHARE) {
        const percentage = 100 - action.payload;
        ecommerce_unit_price_formula = `billed_amount*${percentage}/100`;
      } else if (action.commission_type === COMMISSION_TYPE_UNIT_PRICE) {
        ecommerce_unit_price_formula = `wholesale_price`;
      }

      return {
        ...state,
        ecommerce_unit_price_formula,
        changed: true,
      };
    case DROPSHIP_ALLOWED:
      return {
        ...state,
        approved_for_ecommerce: action.payload,
        changed: true,
      };
    case REPLENISH_ALLOWED:
      return {
        ...state,
        approved_for_replenishment: action.payload,
        changed: true,
      };
    case REPLENISH_SHIPPER_ACCOUNT:
      return {
        ...state,
        replenishment_shipper_account_type: action.payload.provider,
        replenishment_shipper_account: action.payload.account,
        changed: true,
      };
    case PERMISSIONS_TAB:
      return {
        ...state,
        tab: action.payload,
      };
    case PERMISSIONS_MINIMUM_ORDER_PRODUCTS:
      return {
        ...state,
        minimum_products_for_replenishment_order: action.payload,
        changed: true,
      };
    case PERMISSIONS_MINIMUM_ORDER_VALUE:
      return {
        ...state,
        minimum_order_value_for_replenishment_order: action.payload,
        changed: true,
      };
    case PERMISSIONS_FIXED_PER_UNIT:
      if (!isNaN(action.payload)) {
        return {
          ...state,
          replenishment_order_shipping_cost_percentage: 0,
          replenishment_order_shipping_cost_fixed_per_unit: action.payload * 100,
          changed: true,
        };
      }
      break;
    case PERMISSIONS_PERCENTAGE:
      return {
        ...state,
        replenishment_order_shipping_cost_percentage: action.payload,
        replenishment_order_shipping_cost_fixed_per_unit: 0,
        changed: true,
      };

    case REPLENISH_DAYS_UNTIL_OVERDUE: {
      const days = action.payload;

      return {
        ...state,
        settings: { ...state.settings, replenish_days_until_overdue_email: days },
        changed: true,
      };
    }
    case ECOMMERCE_DAYS_UNTIL_OVERDUE: {
      const days = action.payload;

      return {
        ...state,
        settings: { ...state.settings, ecommerce_days_until_overdue_email: days },
        changed: true,
      };
    }
    case CURRENT_RETAILER_TERMS:
      return {
        ...state,
        ...action.payload,
        changed: false,
      };
    case PERMISSIONS_CHANGED:
      return {
        ...state,
        changed: action.payload,
      };
    default:
      break;
  }

  return state;
};

export default permissions;
